module.exports = __webpack_public_path__ + "assets/img/VentureCrowd-Pillar-Page-Resource-w540.e3e384d2.webp";